import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// Shared action/destination editor used by BOTH Buttons (Connect Cards) and Spotlights.
// `action` is any object carrying link_type/form_id/link_value/app_store_url/play_store_url/page_content.
export function ActionFields({ action, onChange, forms = [], idPrefix }) {
  const lt = action.link_type
    || (action.form_id ? "form" : action.link_value ? "url" : (action.app_store_url || action.play_store_url) ? "app_download" : "page");

  return (
    <>
      <div>
        <Label>Action</Label>
        <Select value={lt} onValueChange={(v) => onChange({ link_type: v })}>
          <SelectTrigger className="h-10 mt-1" data-testid={`${idPrefix}-link-type`}><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="page">In-app page (custom content)</SelectItem>
            <SelectItem value="url">External URL (embedded in-app)</SelectItem>
            <SelectItem value="app_download">Download our app (App Store / Play Store QR)</SelectItem>
            <SelectItem value="form">Open a Connect Card</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {lt === "form" ? (
        <div>
          <Label>Connect Card to open</Label>
          <Select value={action.form_id || ""} onValueChange={(v) => onChange({ form_id: v })}>
            <SelectTrigger className="h-10 mt-1" data-testid={`${idPrefix}-form`}><SelectValue placeholder="Select a Connect Card…" /></SelectTrigger>
            <SelectContent>
              {forms.length === 0 && <div className="px-3 py-2 text-sm text-[#5C5856]">No Connect Cards yet — create one in Connections.</div>}
              {forms.map((f) => <SelectItem key={f.form_id} value={f.form_id}>{f.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      ) : lt === "app_download" ? (
        <div className="grid sm:grid-cols-2 gap-4">
          <div><Label>App Store URL (iOS)</Label><Input value={action.app_store_url || ""} onChange={(e) => onChange({ app_store_url: e.target.value })} placeholder="https://apps.apple.com/app/..." className="h-10 mt-1" data-testid={`${idPrefix}-appstore`} /></div>
          <div><Label>Google Play URL (Android)</Label><Input value={action.play_store_url || ""} onChange={(e) => onChange({ play_store_url: e.target.value })} placeholder="https://play.google.com/store/apps/..." className="h-10 mt-1" data-testid={`${idPrefix}-playstore`} /></div>
        </div>
      ) : lt === "url" ? (
        <div><Label>URL</Label><Input value={action.link_value || ""} onChange={(e) => onChange({ link_value: e.target.value })} placeholder="https://yourchurch.com/connect" className="h-10 mt-1" data-testid={`${idPrefix}-url`} /></div>
      ) : (
        <div><Label>Page content</Label><Textarea value={action.page_content || ""} onChange={(e) => onChange({ page_content: e.target.value })} rows={5} placeholder="Welcome! Use the QR code below to connect…" className="mt-1" data-testid={`${idPrefix}-content`} /></div>
      )}
    </>
  );
}
